module.exports = __webpack_public_path__ + "static/media/app_store_button.42c76d76.jpg";